import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
}))

export default useStyles
